
export default function VerificationSection() {
  const verificationPoints = [
    {
      icon: "ri-shield-check-line",
      title: "Background Checks",
      description: "No criminal records or legal issues. We verify every contractor's history.",
      color: "text-green-600"
    },
    {
      icon: "ri-gavel-line",
      title: "No Lawsuits",
      description: "Clean legal record with no pending or past litigation issues.",
      color: "text-blue-600"
    },
    {
      icon: "ri-star-fill",
      title: "4.5+ Star Rating",
      description: "Minimum 4.5-star Google rating with at least 30 verified reviews.",
      color: "text-yellow-500"
    },
    {
      icon: "ri-image-line",
      title: "Portfolio Verified",
      description: "Authentic photos of completed projects, not stock images.",
      color: "text-purple-600"
    },
    {
      icon: "ri-award-line",
      title: "Licensed & Insured",
      description: "Current licenses and comprehensive insurance coverage verified.",
      color: "text-red-600"
    },
    {
      icon: "ri-customer-service-line",
      title: "Customer References",
      description: "Real customer testimonials and references available upon request.",
      color: "text-indigo-600"
    }
  ];

  return (
    <section id="verification" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              Our Rigorous Verification Process
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We don't just connect you with anyone. Every contractor in our network 
              passes our comprehensive screening process to ensure you get quality, 
              trustworthy professionals.
            </p>
            
            <div className="bg-blue-50 rounded-lg p-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <i className="ri-information-line text-blue-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-blue-900 mb-2">Our Promise</h3>
                  <p className="text-blue-800 text-sm">
                    We will not suggest ANYONE who doesn't pass our verification. 
                    Your peace of mind is our priority.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="flex items-center space-x-4 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-green-600"></i>
                <span>100% Verified Network</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-green-600"></i>
                <span>Quality Guaranteed</span>
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {verificationPoints.map((point, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 hover:bg-gray-100 transition-colors duration-200">
                <div className={`w-12 h-12 ${point.color} flex items-center justify-center mb-4`}>
                  <i className={`${point.icon} text-2xl`}></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{point.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
